<template>
  <div>
    <div class='row' id="intro" :class="{hide: step > 0 }">
      <div class="col-md-6">
        <h1>CSV 2 Email</h1>
          Have a spreadsheet with emails that you'd like to send the same templated message to? With this tool you can
          easily send emails everyone to in your spreadsheet, and add variables to your text. These variables will be
          replaced by the values in each row. If you have a column named Order No, then you can put that into your email
          wherever you want it with the text {order-no}. Ex: Your order #{order-no} was successfully received.
      </div>


      <div class="col-md-6">
          <h2 class="h1">Send emails to recipients via CSV</h2>
          <ol>
            <li>Verify your email</li>
            <li>Upload CSV</li>
            <li>Copy and Paste or write your email text</li>
            <li>Add variables from your CSV columns</li>
            <li>Send to all recipients</li>
            <li>You may send {{numAvailable}} emails</li>
          </ol>
      </div>
    </div>
    <div class='row'>
        <div class="progress" v-if="step > 0">
            <div class="progress-bar bg-success" :style="getProgress" role="progressbar" aria-valuenow="0"
              aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </div>
    <div class="row" :class="{'success': step > 0}">
        <div class="col-md-4">
            <h3>Step 1. Verify your email</h3>

        </div>
        <div class="" :class="step < 0 ? 'col-md-8' : 'col-md-7'">
          <verify v-on:step="setStep" v-on:setemail="setEmail"></verify></div>
        <div :class="step > 0 ? 'col-md-1' : 'hidden'">
          <i v-if="step > 0" class='fa fa-check pull-right fa-large'></i>
        </div>
    </div>
    <div class='row' :class="{'success': step > 1}">
      <div class='col-sm-4'>
        <h3 class="pull-left" >Step 2. Upload CSV </h3>
      </div>
      <div class="col-sm-7" v-if="file.name">
        {{file.name}} <i class='fa fa-trash-o' v-on:click="removeFile"></i>
      </div>
      <div class="col-sm-1">
        <i v-if="step > 1"
           class='fa fa-check pull-right fa-larger pull-right'>
        </i>
      </div>
    </div>
    <div class='row' v-if="step == 1">
      <div class='col-sm-12'>
        <div >
            <div class="dropzone-area" @dragenter="hovering = true" @dragleave="hovering = false" :class="{'dropzone-hover': hovering}">
                <div class="dropzone-text">
                    <span class="dropzone-title">Drop CSV here or click to select</span>
                    <span class="dropzone-info" v-if="info">{{ info }}</span>
                </div>
                <input type="file" @change="onFileChange">
            </div>
        </div>
        
        <div v-if="noEmailFound && !emailColumn" class='alert alert-warning padded tcenter margined'>
          <div v-if="emailCols.length > 1">
            More than one column header included the word email, please select which one you want to use.
          </div>
          <div v-else>
            No Email column was found. You must have the keyword "email" in one column header. Please select one or upload a new CSV.
          </div>
          <ul class='select-email'>
            <li v-on:click="setEmailColum(col)" v-for="col in selectCols" class='cols'>{{col}} <i class='fa fa-check'></i></li>
          </ul>
        </div>
        
      </div>
    </div>
    <div class='row' :class="{'success': step > 2}">
      <div class='col-sm-11'><h3>Step 3. Update Email Text</h3></div>
      <div class='col-sm-1'>
         <i v-if="step > 2" class='fa fa-check pull-right'></i>
      </div>
    </div>
    <div class='row' v-if="step > 1 && step < 4">
      <div class='col-md-4'>
        <div class='text' >
          <h5>Live Preview <button class='pull-right' v-on:click="toggleEdit()">Edit <span><i class='fa' :class="{'fa-pencil-square-o': !edit, 'fa-pencil-square': edit}"></i></span></h5>
          <div class='col-md-12'>From:  {{email}}</div>
          <div class='col-md-12'>To: {{currentEmail}}</div>
          <div v-if="!edit" v-on:click="edit = true" class='col-md-12'>Subject: {{currentSubject}}</div>
          <input v-if="edit" type='text' class='col-md-12' v-model='subject' placeholder='Your Subject'>
          <div class='current-text' v-if="!edit" v-on:click="toggleEdit(true)" v-html="currentText"></div>
          <textarea id='editText' v-if='edit' v-model="text"></textarea>
        </div>
        
      </div>
      
      <div class='col-md-8 table-holder'>
        <div class='alert alert-info'>
          <info></info>Click on a column header to add the variable to your email text.
        </div>
        <table class='table table-hover table-border'>
          <thead>
            <tr>
              <th v-for='col in cols' v-on:click="addVariable(col)">{{col}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr :class="{'selected': row==currentRow}" v-on:click="currentRow=row; edit=false" v-for='row in rows'>
              <td v-for="col in row">{{col}}</td>
            </tr>
          </tbody>
        </table>
        
      </div>
      
    </div>
    <div class='row' :class="{'success': step == 4}">
      <div class='col-sm-4'>
        <h3>Step 4. Send</h3></div>
      <div class="col-sm-7" >
        <smtp-info
            v-if="step > 2 && step < 4"
            v-on:error="catchError"
            v-on:sendemail="sendEmail"
            :sending="sending"
            :errors="errors"
            :num-available="numAvailable"
            :email="email"
        >
        </smtp-info>

      </div>
      <div class="col-sm-1"><i v-if="step > 3" class='fa fa-check pull-right'></i></div>
    </div>
    <div v-if="msg" class="alert alert-info">{{ msg }}</div>
  </div>
    
</template>

<script>
  import Vue from 'vue';
  import Papa from 'papaparse';
  import Info from './Info';
  import SmtpInfo from './SmtpInfo';
  import Verify from './Verify';

  export default {
    components: {
      Info,
      SmtpInfo,
      Verify,
    },
    data() {
      return {
        numAvailable: localStorage.getItem('numAvailable') ? localStorage.getItem('numAvailable') : 100,
        file: '',
        hovering: false,
        rows: [

        ],
        cols: ['Salutation', 'First Name', 'Last Name', 'Email', 'Age', 'Gender'],
        subject: 'Your Subject Here',
        text:
                'Dear {first-name},\n\nEnter your email text here as you would normally.\n\nYou can add variables by clicking on the column headers to the right. These will be replaced by the value in each row when you click send.\n\nClick on a row to preview how the email willl look..\n\nThank you\n\nYour Name',
        currentRow: ['mr', 'tom', 'smith', 'tom.smith@email.com', 14, 'M', 'Elementary School'],
        emailColumn: null,
        edit: false,
        step: 0,
        numEmailCol: 0,
        noEmailFound: false,
        emailCols: [],
        token: '',
        errors: [],
        msg: '',
        loading: false,
        sending: false,
        email: '',
      };
    },
    mounted() {
      const url = `${process.env.DOMAIN}/api/token/`;
      Vue.http.get(url).then(
        (data) => {
          Vue.http.headers.common['X-CSRFToken'] = data.body.token;
          this.token = data.body.token;
        }, (error) => {
          console.log(error); //eslint-disable-line
      });
    },
    watch: {
      text(newValue) {
        if (newValue !== this.text) {
          this.step = 2;
        }
      },
    },
    computed: {
      formatObj() {
        const formatObj = [];
        let counter = 0;

        this.cols.forEach((value) => {
          formatObj[this.slugify(value)] = this.currentRow[counter];
          counter += 1;
        });
        return formatObj;
      },
      currentText() {
        return this.format(this.text, this.formatObj).replace(/\n/g, '<br />');
      },
      currentSubject() {
        return this.format(this.subject, this.formatObj);
      },
      currentEmail() {
        const index = this.cols.indexOf(this.emailColumn);
        return this.currentRow[index];
      },
      getProgress() {
        return "width: " + this.step * 25 + "%"; //eslint-disable-line
      },
      selectCols() {
        return this.emailCols.length > 1 ? this.emailCols : this.cols;
      },
    },
    methods: {
      setStep(step) {
        this.step = step;
      },
      catchError(error) {
        this.errors = [error];
        this.loading = false;
      },
      setEmail(email) {
        this.step = 1;
        this.email = email;
      },
      sendEmail(smtp) {
        const rows = [];
        const data = {};
        this.sending = true;
        this.rows.forEach((item) => {
          this.currentRow = item;
          rows.push({
            subject: this.currentSubject,
            text: this.currentText.replace(/<br \/>/g, '\n'),
            email: this.currentEmail,
          });
        });
        data.smtp = smtp;
        data.rows = rows;
        data.csrfmiddlewaretoken = this.token;
        const url = `${process.env.DOMAIN}/api/send-email/`;
        this.loading = true;
        Vue.http.post(url, data).then(
          (response) => {
            if (response.body.success) {
              this.msg = response.body.msg;
              if (!smtp.test) {
                this.step = 4;
              }
              this.numAvailable -= this.rows.length;
              localStorage.setItem('numAvailable', this.numAvailable);
              ga('send', 'event', 'CSV', 'Send', this.rows.length); //eslint-disable-line
            }
          }, (response) => {
          this.errors = response.body.errors;
          this.loading = false;
        }
        ).finally(() => { this.sending = false; });
      },
      toggleEdit(state) {
        this.edit = state || !this.edit;
        this.step = 3;
        ga('send', 'event', 'CSV', 'Edit', 'text'); //eslint-disable-line
      },
      setEmailColum(col) {
        this.emailColumn = col;
        this.step = 1;
        ga('send', 'event', 'CSV', 'Edit', 'header'); //eslint-disable-line
      },
      addVariable(value) {
        const el = document.getElementById('editText');
        const val = '{' + this.slugify(value) + '}'; //eslint-disable-line
        let start;
        let end;

        if (el && el.selectionStart) {
          start = el.selectionStart;
          end = el.selectionEnd;
          if (!end) {
            end = start;
          }

          this.text = this.text.substring(0, start) + val + this.text.substring(end);
          this.edit = true;
        } else {
          this.text += '\n' + val; //eslint-disable-line
        }
        this.step = 3;
        ga('send', 'event', 'CSV', 'Edit', 'variable'); //eslint-disable-line
      },
      slugify(value) {
        return value.toString().toLowerCase()
              .replace(/\s+/g, '-')//eslint-disable-line
              .replace(/[^\w\-]+/g, '')//eslint-disable-line
              .replace(/\-\-+/g, '-')//eslint-disable-line
              .replace(/^-+/, '')//eslint-disable-line
              .replace(/-+$/, '');
      },
      onFileChange(e) {
        const files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        this.createFile(files[0]);
      },
      createFile(file) {
        const self = this;
        this.file = file;
        this.emailCols = [];

        Papa.parse(file, {
          complete(rows) {
            self.numEmailCol = 0;
            self.rows = rows.data.splice(1, rows.data.length - 2);
            if (self.rows.length > self.numAvailable) {
              self.rows = [];
              self.file = false;
              alert(`This CSV contains more rows than your monthly allowance. You Have ${self.numAvailable} left`); //eslint-disable-line
              return false;
            }
            self.currentRow = self.rows[0];
            self.cols = rows.data[0];
            self.emailColumn = null;
            self.noEmailFound = false;

            for (const col of self.cols) {
              if (col.toLowerCase().indexOf('email') > -1) {
                self.emailColumn = col;
                self.emailCols.push(col);
              }
            }

            if (!self.emailColumn) {
              self.noEmailFound = true;
            }

            if (self.emailCols.length > 1) {
              self.noEmailFound = true;
            }

            if (self.noEmailFound) {
              self.emailColumn = false;
              self.step = 1;
            } else {
              self.step = 2;
            }
            ga('send', 'event', 'CSV', 'Upload', self.rows.length); //eslint-disable-line
            return true;
          },
        });
      },
      removeFile() {
        console.log('called'); //eslint-disable-line
        this.file = '';
        this.step = 1;
      },
      format(str, formatObj) {
        let key;
        let value;

        for (key of Object.keys(formatObj)) {
          value = formatObj[key];

          str = str.replace(RegExp("\\{" + key + "\\}", "gi"), value); //eslint-disable-line
        }

        return str;
      },
    },
};
</script>
<style lang="scss" scoped>
  @import "../styles/_variables.scss";
  .row {
    margin-bottom: 1em;
  }
  .text{
    height: 60vh;
    overflow: auto;
    .current-text {
      cursor: pointer;
    }
  }
  .h1 {

  }


  .progress {
    margin-top: 2em;
    display: flex;
    overflow: hidden;
    font-size: .75rem;
    line-height: 1rem;
    text-align: center;
    background-color: #eceeef;
    border-radius: .25rem;
    .progress-bar {
      height: 1rem;
      color: #fff;
      background-color: #0275d8;
    }
  }



  .select-email {
    width: 50%;
    margin: 0 auto;
    li {
      list-style: none;
      &:hover {
        border: 1px solid grey;
        cursor: pointer;
        .fa {
          display: inline-block;
        }
      }
      .fa {
        display: none;
      }
    }
  }
  .table-holder {
    height: 60vh;
    overflow: auto;

    th {
      pointer: cursor;
    }

    tr {
      &.selected {
        background-color: #cdcdcd;
      }

      &:hover {
        cursor: pointer;
      }
    }
  }
  .alert {
    &.padded {
      padding: 1em;
    }
    &.margined {
      margin-top: 1em;
    }
  }
  .inputs {
    label {
      display: inline-block;

      cursor: pointer;
    }
    input {
      margin-bottom: 1em;
      padding: 0.5em;
    }
    .padded {
      padding-top: 0.5em;
      padding-bottom: 0.5em;
    }
  }

  #intro {
	 overflow-y: hidden;
	 max-height: 200px; /* approximate max height */

	 transition-property: all;
	 transition-duration: .5s;
	 transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
     &.hide {
       max-height: 0;
     }
  }

  .fa-check {
    color: $green;
  }
  .success {
    h3 {
      font-size: 0.8em;
    }
  }

</style>



// WEBPACK FOOTER //
// FileUpload.vue?19c00477